import { z } from 'zod'

export const ContactSchema = z.object({
  name: z.string().min(1, {
    message: 'Name is required',
  }),
  phone: z.string().min(1, {
    message: 'Phone is required',
  }),

  message: z.string().min(1, {
    message: 'Message is required',
  }),
})
